var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 18.8309C18.875 19.1072 18.7653 19.3722 18.5699 19.5675C18.3746 19.7629 18.1096 19.8726 17.8333 19.8726H1.16667C0.8904 19.8726 0.625448 19.7629 0.430097 19.5675C0.234747 19.3722 0.125 19.1072 0.125 18.8309V7.88301C0.12489 7.72428 0.16106 7.56761 0.230746 7.42499C0.300432 7.28237 0.401792 7.15756 0.527083 7.0601L8.86042 0.578848C9.04327 0.436603 9.26833 0.359375 9.5 0.359375C9.73167 0.359375 9.95673 0.436603 10.1396 0.578848L18.4729 7.0601C18.5982 7.15756 18.6996 7.28237 18.7693 7.42499C18.8389 7.56761 18.8751 7.72428 18.875 7.88301V18.8309V18.8309ZM8.45833 11.5393V17.7893H10.5417V11.5393H8.45833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.aa28a3e1225dedf6f4863baaecc6fab9.svg";
export { ForwardRef as ReactComponent };